import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import { updateProfessionalDetailsUpdateApi, userProfessionalInfoGetApi, roleListGetApi, roleDataUpdateApi } from '../Model/ProfessionalModel';

import * as Store from '../../../../../store'
let version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";

export const userProfessionalInfoGet = (id) => {
    return get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}user_professional_info/${id}`).then((response) => {
        return userProfessionalInfoGetApi(response)
    });
};


export const updateProfessionalDetailsUpdate = (data, type, id,) => {
    return patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}user_professional_info/${id}`, data).then((response) => {
        return updateProfessionalDetailsUpdateApi(response)
    });
};

export const roleDataUpdate = (data, type, id,) => {
    return patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}admin/${id}`, data).then((response) => {
        return roleDataUpdateApi(response)
    });
};

export const roleListGet = (data) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    return get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles`, data).then((response) => {
        return roleListGetApi(response)
    });
};